const getters = {
  errorLog: state => state.errorLog.logs
}

export default getters
